/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Task_Assigned_HeadingInputs */

const en_email_task_assigned_heading = /** @type {(inputs: Email_Task_Assigned_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have a new task`)
};

const pt_br2_email_task_assigned_heading = /** @type {(inputs: Email_Task_Assigned_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você tem uma nova atividade`)
};

/**
* | output |
* | --- |
* | "You have a new task" |
*
* @param {Email_Task_Assigned_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_heading = /** @type {((inputs?: Email_Task_Assigned_HeadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_HeadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_heading(inputs)
	return pt_br2_email_task_assigned_heading(inputs)
});